const toggleModal = ({ commit }, payload) => {
    commit('TOGGLE_MODAL', payload);
};

export default { toggleModal };
